import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import InfoTrabajadores from "../../Funciones/InfoTrabajadores";
import { obtenerSedes, sedesPorInstitucionId } from "../../../Services/Rest";

const CreaTrabajadores = () => {
  const cookies = new Cookies();

  const [list2, setList2] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [postFechaCorte, setPostFechaCorte] = useState("");
  const [archivos, setArchivos] = useState(null);
  const [selectedValue, setSelectedValue] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const tipoUsuario = cookies.get("tipo_Usuario");
  const institucionId = cookies.get("institucionid");

  const urlendpoint =
    tipoUsuario == 1 || tipoUsuario == 4
      ? obtenerSedes
      : `${sedesPorInstitucionId}${institucionId}`;

  useEffect(() => {
    axios
      .get(urlendpoint, {
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
      })
      .then((response) => {
        setList2(response.data);
      })
      .catch((error) => {
        console.error(error);
        Swal.fire("Error", "No se pudieron cargar las sedes", "error");
      });
  }, [urlendpoint]);

  const subirArchivos = (files) => {
    setArchivos(files);
  };

  const mostrarResultado = (data, esError = false) => {
    let html = `
      <div style="text-align:left; max-height:400px; overflow-y:auto;">
        <p><strong>${data.mensaje || "Resultado de la carga"}</strong></p>
        <hr/>
        <p><b>Registros Totales:</b> ${data.registrosTotales ?? 0}</p>
        <p><b>Registros Cargados:</b> ${data.registrosCargados ?? 0}</p>
    `;

    if (data.errores?.length) {
      html += `<hr/><p><b>Errores encontrados:</b></p><ul>`;
      data.errores.forEach((error) => {
        html += `<li>${error}</li>`;
      });
      html += `</ul>`;
    }

    html += `</div>`;

    Swal.fire({
      icon: esError || data.registrosCargados === 0 ? "error" : "success",
      title: "Resultado",
      html: html,
      width: 700,
      confirmButtonText: "Cerrar",
    });
  };

  const insertarArchivos = async () => {
    if (!archivos?.length) {
      return Swal.fire(
        "Atención",
        "Debe seleccionar al menos un archivo",
        "warning",
      );
    }

    if (!postFechaCorte || !selectedValue) {
      return Swal.fire(
        "Atención",
        "Debe seleccionar sede y año de corte",
        "warning",
      );
    }

    const formData = new FormData();
    Array.from(archivos).forEach((file) => {
      formData.append("files", file);
    });

    setLoading(true);

    try {
      const { data } = await axios.post(
        `https://suadesarrollo.azurewebsites.net/api/CargaMasivosTrabajadores?InstitucionId=${institucionId}&FechaCorte=${postFechaCorte}&SedeId=${selectedValue}`,
        formData,
      );

      mostrarResultado(data);

      if (data.registrosCargados > 0) {
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (error) {
      const data = error.response?.data;

      if (data) {
        mostrarResultado(data, true);
      } else {
        Swal.fire("Error", "Error inesperado al cargar el archivo", "error");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Sube el documento
          </h6>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <hr />

            <select
              className="btn btn-secondary btn-user btn-block"
              onChange={(e) => setSelectedValue(e.target.value)}
              value={selectedValue}
            >
              <option value="">Seleccione la sede</option>
              {list2
                .filter((item) =>
                  item.nombre.toLowerCase().includes(searchTerm.toLowerCase()),
                )
                .map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.nombre}
                  </option>
                ))}
            </select>

            <hr />

            <table className="table table-bordered" width="100%">
              <tbody>
                <tr>
                  <td>
                    <input
                      type="file"
                      accept=".csv"
                      multiple
                      onChange={(e) => subirArchivos(e.target.files)}
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Año de corte ejemplo: 2024"
                      onChange={(e) => setPostFechaCorte(e.target.value)}
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <hr />

            <button
              className="btn btn-primary btn-user btn-block"
              onClick={insertarArchivos}
              disabled={isLoading}
            >
              {isLoading ? "Cargando..." : "Guardar"}
            </button>
          </div>
        </div>
      </div>

      <InfoTrabajadores />
    </div>
  );
};

export default CreaTrabajadores;
